module.exports = "<div class=\"service-item-container\"\r\n     wow wow-animation=\"bounceIn\" [wow-delay-md]=\"delay\"\r\n>\r\n  <div class=\"service-item\">\r\n    <div class=\"service-item-header\">\r\n      <span>{{service.name}}</span>\r\n    </div>\r\n    <div class=\"service-item-body\">\r\n      <h4 class=\"service-heading\">{{service.headerText}}</h4>\r\n      <p>{{service.description}}</p>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/services/service-card/service-card.component.html
// module id = ../../../../../src/app/services/service-card/service-card.component.html
// module chunks = main